import * as Yup from 'yup';

export const ValidationSchema = Yup.object({
    pcounter_id: Yup.string().required('Id People Counter Sensor'),
})

